import { render, staticRenderFns } from "./DeactivationConfirmation.vue?vue&type=template&id=04adbb21"
import script from "./DeactivationConfirmation.vue?vue&type=script&lang=js"
export * from "./DeactivationConfirmation.vue?vue&type=script&lang=js"
import style0 from "./DeactivationConfirmation.vue?vue&type=style&index=0&id=04adbb21&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports